import React from "react";
import cn from "classnames";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";

export type SpacingBlockType = Omit<FormBlockType, "data"> & {
    data: {
        space: "small" | "medium" | "large";
    },
}

export default function SpacingBlock(block: SpacingBlockType) {
    const { data: { space } } = block;
    const spaceCn = cn(
        "w-full",
        space == "small" ? "mt-5" : "",
        space == "medium" ? "mt-10" : "",
        space == "large" ? "mt-20" : "",
    );

    return (
        <div className={spaceCn}/>
    );
}
